import AppsContainer from "../../components/UmmIACategories/AppsContainer";
import HeaderCategoria from "../../components/UmmIACategories/HeaderCategoria";
import UmmIAHogarCardImg from "../../components/Home/img/UmmIAHogarCardImg.png";

const UmmIAARGPage = () => {
  return (
    <>
      {/* Contenedor de cabecera */}
      <HeaderCategoria
        titulo="UmmIA Hogar"
        descripcion="Aplicaciones y juegos lúdicos para niños que ayudan a fortalecer su aprendizaje."
        img={UmmIAHogarCardImg}
        alt="Imagen UmmIA Hogar"
        primaryColor="#336B87"
        secondaryColor="#F8FDFE"
        thirdColor="#9ADEF5"
        backButton="#336B87"
        secondPercentage="30"
      />

      {/* Contenedor de tarjetas: se renderizan solo las apps a las que el usuario tiene acceso */}
      <AppsContainer filter="UmmIAHogar" />
    </>
  );
};

export default UmmIAARGPage;
